import { ScheduleDetails } from "./schedule-details.model";

export interface ScheduleHistory {
    advisorId: number;
    advisorName: string;
    campaignsIds: number[];
    checkInHour: number;
    country: string;
    customerId: number;
    customerName: string;
    dealerCity: string;
    dealerId: number;
    dealerName: string;
    dealerState: string;
    dealerStreet: string;
    deliveryScheduleDate: string;
    deliveryScheduleHour: number;
    divisionId: number;
    lastKm: number;
    modelYear: number;
    prisma: number;
    remark: string;
    scheduleDate: string;
    scheduleHour: number;
    scheduleId: number;
    vehicleModel: string;
    vehiclePlate: string;
    vehicleImage: string;
    vin: string;
    parsedDate: string;
    extendedDate: string;
    scheduleDateToDateType: Date;
    scheduleDetails: ScheduleDetails;
}
